import React from 'react';
import { useIntl } from 'react-intl';

import { wizardModeOptions } from 'Models/Enums';
import { TripDetailsModel } from 'Modules/TripDetails/TripDetails';
import { Button } from 'Views/Components/Button/Button';
import { Alignment, ButtonGroup } from 'Views/Components/Button/ButtonGroup';

export interface TripTypeButtonsProps {
	typeSelected: string;
	onTabSelected: (direction: 'one way' | 'return') => void;
	model: TripDetailsModel;
}

export function TripTypeButtons({ typeSelected, onTabSelected, model }: TripTypeButtonsProps) {
	const intl = useIntl();
	return (
		<ButtonGroup className="trip-type-btn-group" alignment={Alignment.HORIZONTAL}>
			<Button
				className={typeSelected === 'one way' ? 'selected-btn' : 'unselected-btn'}
				onClick={() => onTabSelected('one way')}
				disabled={model.wizardData.wizardMode === wizardModeOptions.ALTERATION}
				buttonProps={{ 'data-test-id': 'wizard-trip-type-one-way' } as any}
			>
				{intl
					.formatMessage({
						id: 'booking-type__one-way__label',
						defaultMessage: 'One way',
					})
					.toUpperCase()}
			</Button>
			<Button
				className={typeSelected === 'return' ? 'selected-btn' : 'unselected-btn'}
				onClick={() => onTabSelected('return')}
				disabled={
					model.wizardData.wizardMode === wizardModeOptions.ALTERATION ||
					model.wizardData.tabSelected === 'freight'
				}
				buttonProps={{ 'data-test-id': 'wizard-trip-type-return' } as any}
			>
				{intl
					.formatMessage({
						id: 'booking-type__return__label',
						defaultMessage: 'Return',
					})
					.toUpperCase()}
			</Button>
		</ButtonGroup>
	);
}
